// extracted by mini-css-extract-plugin
export default {"div-results":"SectionResults_div-results__eR7Q2","results-container":"SectionResults_results-container__EpwBe","buttons-container":"SectionResults_buttons-container__7bt4N"};